<template>
  <SectionContainer v-if="isLoading || publicCourses.length" class="fluid-x">
    <SectionHeader>
      <template #title>
        <b>Conteúdo gratuito</b>
      </template>
      
      <template #subtitle>
        Conhecimento acessível para quem quer crescer!
      </template>
    </SectionHeader>

    <LoadingIcon v-if="isLoading" />
  
    <HorizontalCarousel v-else :items="publicCourses">
      <template v-slot="{ item }">
        <CourseThumbBox
          :course="item"
          class="course-thumb-box"
        >
          <BaseBadge
            class="primary outline"
          >Aulas grátis disponíveis!</BaseBadge>
        </CourseThumbBox>
      </template>
    </HorizontalCarousel>
  </SectionContainer>
</template>

<script> 
  import SectionContainer from '@/components/layout/SectionContainer'
  import SectionHeader from '@/components/layout/SectionHeader'
  import CourseThumbBox from '@/components/course/CourseThumbBox'
  import HorizontalCarousel from '@/components/carousel/HorizontalCarousel'
  import LoadingIcon from '@/components/layout/LoadingIcon'
  import { fetchPublicCourses } from '@/api/course.api'
  import BaseBadge from '@/components/badges/BaseBadge'


  export default {
    components: {
      SectionContainer,
      SectionHeader,
      CourseThumbBox,
      HorizontalCarousel,
      LoadingIcon,
      BaseBadge,
    },

    data: () => ({
      isLoading: false,
      publicCourses: []
    }),   

    async mounted () {    
      this.isLoading = true
      
      await this.getPublicCourses()

      this.isLoading = false
    },

    methods: {  
      async getPublicCourses() {
        this.publicCourses = await fetchPublicCourses()       
      }
    }
  }
</script>